import moment from "moment"

export default function () {
    return function (date) {
        return moment(date).add(8, "h").format('YYYY-MM-DD HH:mm')
    }
}